import { EventEmitter } from 'eventemitter3';
import { InterceptorManager } from '../helper';
import { InterceptorLoginConfig } from '../types';

interface Interceptors {
  login: InterceptorManager<InterceptorLoginConfig>;
}

export class Base extends EventEmitter {
  public interceptors: Interceptors;

  constructor() {
    super();

    this.interceptors = {
      login: new InterceptorManager<InterceptorLoginConfig>(),
    };
  }
}
